export default function (array, key = 'key', value = 'value') {
	return array.find((object) => object[key] === value) || false;
}
